export enum ComparisonRelation {
  GreaterThan = 'greater_than',
  LessThan = 'less_than',
  Equals = 'equals',
}

export type RelationItem = {
  value: string;
  relation: ComparisonRelation;
};

export const isRelationFulfilled = (
  value?: string,
  relationItem?: RelationItem,
) => {
  if (!value || !relationItem) {
    return false;
  }
  switch (relationItem.relation) {
    case ComparisonRelation.GreaterThan:
      return value > relationItem.value;
    case ComparisonRelation.LessThan:
      return value < relationItem.value;
    case ComparisonRelation.Equals:
      return value === relationItem.value;
    default:
      return false;
  }
};
